import {Component, OnInit, Input} from '@angular/core'

@Component({
  selector: 'dmmp-shared-text',
  templateUrl: './text.component.html'
})
export class TextComponent implements OnInit {
  @Input() textEnriched
  @Input() classTextEnriched
  @Input() quantityCharacters
  @Input() buttonShow
  @Input() class = 'summarized'
  ngOnInit() {}

  changeQuantity() {
    this.class = ''
    this.buttonShow = false
    this.quantityCharacters = this.textEnriched.length
  }
}
